import * as THREE from 'three';
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import gsap from 'gsap';
import Tools from '../utils/Tools';
import { GameConfig, PlatformsDesign } from '../utils/GameConfig';
import tools from 'tools';
import config from 'config';
import { Point } from 'pixi.js';
import { DEG2RAD } from 'three/src/math/MathUtils';


export default class Platforms extends THREE.Object3D {
    constructor(options) {
        super();

        this._scoreAdd = document.querySelector('.js-score-add');

        this.wordings = { perfect: document.querySelector(".wording-perfect"), good: document.querySelector(".wording-good"), bad: document.querySelector(".wording-bad") };

        GameManager.SCORE = 0;

        this.update = this.update.bind(this);
        this.restart = this.restart.bind(this);
        this.retry = this.retry.bind(this);
        this._destroyAllPlatforms = this._destroyAllPlatforms.bind(this);
        this._setupRespawnPlatform = this._setupRespawnPlatform.bind(this);
        this._setupRandomPlatforms = this._setupRandomPlatforms.bind(this);
        this._setupBoostArrow = this._setupBoostArrow.bind(this);
        this._renderInstance = this._renderInstance.bind(this);


        // The elapsed time for the clock when pause
        this.pauseElapsedTime = null;

        // Setup all the parameters
        this.clock = new THREE.Clock();

        // Velocity of the ball
        this._ballVelocity = null;

        // Droping time when the drop begins
        this._droppingBeginTime = 0;

        // Configuration for the rotation
        this._rotationValue = 0.786;

        // Data for the instance object
        this._platformArr = [];
        this._platformPiecesData = [];
        this._platformTotalLayerNum = null;
        this._platformInstanceObject = null;

        // The torus effect of invincible collision
        this._invincibleCollisionEffect = null;

        // The three examples of splash meshes
        this._splashMeshes = [];

        // The current splash meshed
        this._currentSplashMeshed = [];

        // Distance of dropping since the ball left platform
        this._droppingDistance = 0;
        // Number of platforms passed without touch them
        this._scoreBoostMultiplier = 0;
        // Score boost
        this._scoreBoost = 0;
        // Is score boost event already dispatched, 2 levels exist
        this._scoreBoostEventDispatchedL1 = false;
        this._scoreBoostEventDispatchedL2 = false;

        // The last boost arrow level
        this._lastBoostArrowLevel = 0;

        // Detune sound value
        this._detuneSoundValue = 0;
        // If _isBallInvincible is true, next platform will break with yellow and will not fail
        this._isBallInvincible = false;

        // The value becomes true after the retry, if true destroy the first platform not the actual
        this._isFirstGoingDownAfterRetry = false;

        // Current platform level
        this._platformLevelIndex = 0;

        // List of platforms been destroyed
        this._platfromLevelDestroyedList = [];

        this._clockLevelDestroy = new THREE.Clock();

        // Is the boost arrow animation is playing
        this._isBoostAnimationPlaying = false;

        // The boost arrow in the scene
        this._boostArrow = null;
        // The array of all the boost arrow
        this._boostArrowsArray = [];

        // A static box representing the position of the ball
        this._ballBox = null;

        // Setup all the state
        this._isGoingDown = false;



    }

    /** 
     * Public 
    */

    build() {

        // Set the initial velocity
        this._ballVelocity = GameConfig.velocityNormal;

        // Set up the platform model
        this._normalPlatform = AssetsManager.models.PieMin.scene.clone();
        this._normalPlatformMaterial = new THREE.MeshStandardMaterial({
            // side: THREE.DoubleSide,
            color: new THREE.Color(GameManager.gameColors.normalPlatformColor),
            // wireframe: true,
        });
        this._normalPlatform.traverse((child) => {
            if (child.isMesh) {
                child.material = this._normalPlatformMaterial;
            }
        });

        this._bonusPlatformMaterial = new THREE.MeshStandardMaterial({
            color: new THREE.Color(GameManager.gameColors.ballColorNormal),
        });

        this._losePlatform = AssetsManager.models.PieMin.scene.clone();
        this._losePlatformMaterial = new THREE.MeshStandardMaterial({
            side: THREE.DoubleSide,
            color: new THREE.Color(GameManager.gameColors.losePlatformColor),
            // depthWrite: false,
            // wireframe: true,
        });

        this._losePlatform.traverse((child) => {
            if (child.isMesh) {
                child.material = this._losePlatformMaterial;
            }
        });
        this._losePlatform.scale.set(1.01, 1.01, 1.01);

        this.loopIndexLimit = 0;
        this.loopIndexLimitId = GameConfig.loopIndexLimitId;

        for (let i = 0; i < GameConfig.levelGenerator.length - this.loopIndexLimitId; i++) {

            this.loopIndexLimit += GameConfig.levelGenerator[i].count;

        }

        this._setupRespawnPlatform();
        this._setupRandomPlatforms();
        this._setupBoostArrow();
        this._setupInvincibleCollisionEffect();

        for (let index = 0; index < 3; index++) {
            this._setupSplashTextures(index);
        }

        this._renderInstance();
    }


    update() {
        const clockDelta = this.clock.getDelta();

        // Movement of the platform
        if (this._isGoingDown) {
            //console.log('timeDelta', this.clock.elapsedTime, this._droppingBeginTime);
            var timeDelta = this.clock.elapsedTime - this._droppingBeginTime;
            this._ballVelocity = GameConfig.initialVelocity + GameConfig.gravitationalAcceleration * timeDelta;
            const speedLimit = GameConfig.initialVelocity + GameConfig.timeForMaxVelocity * GameConfig.gravitationalAcceleration;
            if (this._ballVelocity > speedLimit) {
                this._ballVelocity = speedLimit;
            }

            // Move this object upwards
            var deltaDistance = clockDelta * this._ballVelocity;
            this.position.y += deltaDistance;

            // If the dropping distance 
            this._droppingDistance += deltaDistance;
            //const currentMultiplier = Math.floor((this._droppingDistance - 0.13 * (this._scoreBoostMultiplier + 1)) / GameConfig.platformOffset);

            var currentMultiplier = Math.floor((this._droppingDistance - 0.47223) / GameConfig.platformOffset);
            if (currentMultiplier == -1) {
                currentMultiplier = 0;
            }
            if (currentMultiplier > this._scoreBoostMultiplier) {
                //console.log("this._droppingDistance", this._droppingDistance, "currentMultiplier", currentMultiplier, "this._scoreBoostMultiplier", this._scoreBoostMultiplier);
                this._detuneSoundValue += 0.4;
                this.goingDown();
            }
            this._scoreBoostMultiplier = currentMultiplier;

            // If the currentMultiplier bigger than 0 change ball state
            if (currentMultiplier > 0 && !this._scoreBoostEventDispatchedL1 && !this._isBallInvincible) {
                // If the ball is already on super fire speed don't change ball state and speed
                GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "ballStatusChange", data: 'fire' });

                this._scoreBoostEventDispatchedL1 = true;
            }

            // If the currentMultiplier bigger than 2 change ball state
            if (currentMultiplier > 1 && !this._scoreBoostEventDispatchedL2) {
                // If the ball is already on super fire speed don't change ball state and speed
                GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "ballStatusChange", data: 'superFire' });

                this._scoreBoostEventDispatchedL2 = true;

                // The ball become invincible for one bounce
                this._isBallInvincible = true;
                this.invinsibleCheck();
            }
        }
        else {
            if (this._scoreBoostEventDispatchedL1 || this._scoreBoostEventDispatchedL2) {
                GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "ballStatusChange", data: 'normal' });
                this._scoreBoostEventDispatchedL1 = false;
                this._scoreBoostEventDispatchedL2 = false;
            }

            // // Reset some parameters
            // this._droppingDistance = 0;
            // this._scoreBoostMultiplier = 0;
            // this._detuneSoundValue = 0;
        }

        this._detectAABBCollision();
    }

    // Call by the Ball if it hit the platforms
    detectCollision(objectCollision) {
        //console.log("detecting collision", objectCollision);
        if (config.losePlatformTouched) {
            return;
        }

        // Dispatch the event
        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "bounce" });

        // If hit the cracked piece, return error
        const objectCollisionLayer = this._platformPiecesData[objectCollision.instanceId].layer;
        if (this._platfromLevelDestroyedList.includes(objectCollisionLayer)) {
            //console.log("objectCollisionLayer", objectCollisionLayer);
            return "error";
        }

        // Reset some parameters
        this._droppingDistance = 0;
        this._scoreBoostMultiplier = 0;
        this._detuneSoundValue = 0;

        this._isGoingDown = false;

        // Place the platform on the right position
        const platformPositionY = this.position.y;
        //console.log(platformPositionY, Math.round(platformPositionY / GameConfig.platformOffset) * GameConfig.platformOffset);
        this.position.y = Math.round(platformPositionY / GameConfig.platformOffset) * GameConfig.platformOffset;

        // Set the platform level index according to the object collision
        const indexObjectCollision = objectCollision.instanceId;
        //console.log(this._platformPiecesData[indexObjectCollision]);
        this._platformLevelIndex = this._platformPiecesData[indexObjectCollision].layer;

        // For the facebook version, sometimes some platforms don't get destroyed because of the lag, so verify and destroy all above platforms
        for (let index = 1; index < this._platformLevelIndex - 1; index++) {
            if (!this._platfromLevelDestroyedList.includes(index)) {
                this.destroyPlatform(index);
            }
        }

        // If the ball is invincible, will not game over and will not splash, will destroy the platform
        const objectCollisionType = this._platformPiecesData[objectCollision.instanceId].type;

        // console.log("objectCollisionType:", objectCollisionType)

        if (!this._isBallInvincible) {
            // If the object is red block game over

            if (objectCollisionType === "losePlatform" && !GameManager.ball.isShielded) {
                console.log("losePlatform touched");
                config.losePlatformTouched = true;

                // Emit big particle effect
                GameManager.ball.emitBigParticleEffect();

                GameManager.ball.stopAnimation(() => {

                    if (GameManager.GAME.isFirstLose) {

                        //console.log("First lose game", this._platformPiecesData[objectCollision.instanceId]);
                        // First lose
                        GameManager.uiManager.showTryAgain();
                        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "gameFirstLose", data: '' });
                    }
                    else {
                        //TODO
                        // Emit lose particle
                        // Normal lose
                        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "gameNormalLose", data: '' });
                    }

                });
                config.losePlatformTouched = true;
            }

            // Add splash image to this
            const splashMesh = this._splashMeshes[Tools.randomNum(0, 2)].clone();
            const splashMaterial = splashMesh.material.clone();
            splashMesh.material = splashMaterial;
            splashMesh.material.color.set(new THREE.Color(GameManager.gameColors.ballColorNormal));
            splashMesh.position.copy(this.worldToLocal(objectCollision.point));
            splashMesh.position.y += 0.03;
            splashMesh.rotation.z = Math.PI * Math.random();
            this._currentSplashMeshed.push(splashMesh);
            this.add(splashMesh);

            // Play the splash image animation
            gsap.to(splashMesh.material, { opacity: 0, duration: 1, delay: 1 });
            gsap.delayedCall(2, () => {
                this.remove(splashMesh);
            });
        }
        else {
            this.destroyPlatform(this._platformLevelIndex, "changeToYellow");

            // Play the collision effect
            this._invincibleCollisionEffect.position.y = -this.position.y;
            gsap.fromTo(this._invincibleCollisionEffect.scale, { x: 0, y: 0, z: 0 }, { x: 1, y: 1, z: 1, duration: 1, ease: "power2" });
            gsap.fromTo(this._invincibleCollisionEffect.material, { opacity: 1 }, { opacity: 0, duration: 1, ease: "power2" });

            // Emit big particle effect
            GameManager.ball.emitBigParticleEffect();
        }

        // Set the ball back to normal
        this._isBallInvincible = false;
        GameManager.ball.isBooster = false;

        // Play the sound and haptic feedback
        if (GameManager.GAME.isFirstClick) {
            GameManager.soundManager.playSound({ name: "Splash", volume: 0.005, loop: false, detuneValue: 0 });
        }

        if (!GameManager.GAME.isDebug) {
            if (GameManager.hapticManager && GameManager.hapticManager.isHapticEnabled()) {
                GameManager.H5SDK.getHapticModule().performHapticFeedBack(100);
            }
        }

        // Reset the score boost
        this._scoreBoost = 0;

        // Reset the velocity
        this._ballVelocity = GameConfig.initialVelocity;


    }

    goingDown(isGoingDownAlready = true, isPlayDestroyAnimation = true) {
        //console.log("goingDown");

        this._isGoingDown = true;

        // If isGoingDownAlready is false, reset the velocity
        if (!isGoingDownAlready) {
            this._ballVelocity = GameConfig.initialVelocity;
            this._droppingBeginTime = this.clock.elapsedTime;
        }

        // Hide all the splashMesh
        for (let index = 0; index < this._currentSplashMeshed.length; index++) {
            this._currentSplashMeshed[index].visible = false;
        }

        if (!this._isFirstGoingDownAfterRetry && isPlayDestroyAnimation) {
            this.destroyPlatform(this._platformLevelIndex, "normal");
        }

        if (this._isFirstGoingDownAfterRetry && isPlayDestroyAnimation) {
            this.destroyPlatform(0, "normal");
            this._isFirstGoingDownAfterRetry = false;
        }

        // Platform level plus 1
        this._platformLevelIndex += 1;

        // Set up the boost arrow dynamically
        this._setupBoostArrow();
    }

    destroyPlatform(levelOfPlatform, style = "normal") {
        //console.log("destroyPlatform", levelOfPlatform, style);

        // Dispatch the event
        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "destoryPlatform" });

        // Verify if this level of platform is already destroyed
        if (this._platfromLevelDestroyedList.includes(levelOfPlatform)) {
            return;
        }
        else {
            this._platfromLevelDestroyedList.push(levelOfPlatform);
        }

        // Play the sound
        if (GameManager.GAME.isFirstClick) {
            GameManager.soundManager.playSound({ name: "Platform", volume: 0.01, loop: false, detuneValue: this._detuneSoundValue });
        }

        // Add the score
        if (GameManager.GAME.isLose) return;
        GameManager.SCORE += 20;
        this._scoreBoost += 20;

        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "score" });

        // Add the coin
        GameManager.COIN += 2;


        // Haptic feedback
        if (GameManager.hapticManager && GameManager.hapticManager.isHapticEnabled()) {
            //GameManager.H5SDK.performHapticFeedBack(100);
        }

        // Register the score
        //GameManager.H5SDK.notifyUpdateScore(GameManager.SCORE);

        // Show add score ui
        GameManager.uiManager.addScore(this._scoreBoost);

        // Destroy the upper layer of platform
        // Find the platform piece data with the same _platformLevelIndex
        const arrayOfIndexRequestedPlatform = [];
        for (let index = 0; index < this._platformPiecesData.length; index++) {
            const element = this._platformPiecesData[index];
            if (element.layer == levelOfPlatform) {
                arrayOfIndexRequestedPlatform.push(this._platformPiecesData.indexOf(element));
            }
        }
        //console.log(arrayOfIndexRequestedPlatform);

        // Change the color of the platform if needed
        if (style == "changeToRed") {
            for (let index = 0; index < arrayOfIndexRequestedPlatform.length; index++) {
                const indexOfInstance = arrayOfIndexRequestedPlatform[index];

                this._platformInstanceObject.setColorAt(indexOfInstance, new THREE.Color(0xff0000));
                this._platformInstanceObject.instanceColor.needsUpdate = true;
            }
        }

        if (style == "changeToYellow") {
            for (let index = 0; index < arrayOfIndexRequestedPlatform.length; index++) {
                const indexOfInstance = arrayOfIndexRequestedPlatform[index];

                this._platformInstanceObject.setColorAt(indexOfInstance, new THREE.Color(0xf6ff00));
                this._platformInstanceObject.instanceColor.needsUpdate = true;
            }

            // Show praises
            GameManager.uiManager.showPraises();
        }

        const randChunksIndexRequestedPlatform = Tools.randChunkSplit(arrayOfIndexRequestedPlatform, GameConfig.chunkSplitMin, GameConfig.chunkSplitMax);
        //console.log(randChunksIndexRequestedPlatform);

        const randomRotationAddon = Tools.rand(-Math.PI, Math.PI);

        // For each chunk of the platform play the destroy animation
        for (let index1 = 0; index1 < randChunksIndexRequestedPlatform.length; index1++) {
            const randChunkIndexRequestedPlatform = randChunksIndexRequestedPlatform[index1];

            // Dummy rotation of the chunk
            const xChunkRotationDegree = Tools.rand(-90, 90);
            const zChunkRotationDegree = Tools.rand(-120, 0);

            // Dummy position of the chunk
            const middleIndexOfChunk = Math.floor(randChunkIndexRequestedPlatform.length / 2);
            //console.log(middleIndexOfChunk);
            const chunkOriginalRotationY = this._platformPiecesData[randChunkIndexRequestedPlatform[middleIndexOfChunk]].rotation.y - this.rotation.y;
            // Force the pieces to move back instead of move forward
            //var simplifyRad = Tools.simplifyRad(chunkOriginalRotationY);
            //var remapRad = Tools.remapValue(0, 2*Math.PI, simplifyRad, 0.25 * Math.PI, 1.75 * Math.PI);
            //console.log(simplifyRad);
            const xChunkPosition = - Math.cos(chunkOriginalRotationY) * 15;
            const yChunkPosition = - this.position.y - 30;
            const zChunkPosition = Math.sin(chunkOriginalRotationY) * 15;

            const chunkLocalPosition = new THREE.Vector3(xChunkPosition, yChunkPosition, zChunkPosition);
            const chunkWorldPosition = this.localToWorld(chunkLocalPosition);

            // For each piece of the chunk, play the destroy animation
            for (let index = 0; index < randChunkIndexRequestedPlatform.length; index++) {
                let dummy = new THREE.Object3D();
                const indexOfInstance = randChunkIndexRequestedPlatform[index];

                // Save the original position y
                const dummyOriginalPositionY = this._platformPiecesData[indexOfInstance].position.y;
                //console.log("dummyOriginalPositionY", dummyOriginalPositionY);

                dummy.position.set(this._platformPiecesData[indexOfInstance].position.x, this._platformPiecesData[indexOfInstance].position.y, this._platformPiecesData[indexOfInstance].position.z);
                dummy.rotation.set(this._platformPiecesData[indexOfInstance].rotation.x, this._platformPiecesData[indexOfInstance].rotation.y, this._platformPiecesData[indexOfInstance].rotation.z);
                dummy.scale.set(this._platformPiecesData[indexOfInstance].scale.x, this._platformPiecesData[indexOfInstance].scale.y, this._platformPiecesData[indexOfInstance].scale.z);
                //console.log("this._platformPiecesData[indexOfInstance].position.y", this._platformPiecesData[indexOfInstance].position.y);

                //console.log(this.position.y);
                //console.log(this.rotation.y);
                gsap.to(dummy.rotation, {
                    x: xChunkRotationDegree * Tools.DEG2RAD,
                    //y: Tools.rand(-45, 45) * Tools.DEG2RAD,
                    z: zChunkRotationDegree * Tools.DEG2RAD,
                    duration: 2, delay: 0.3, ease: "none",
                });

                gsap.to(dummy.position, {
                    x: chunkWorldPosition.x,
                    z: chunkWorldPosition.z,
                    duration: 2, delay: 0.1, ease: "none",
                });

                gsap.to(dummy.position, {
                    y: yChunkPosition,
                    duration: 1.5, delay: 0.1, ease: "power1.in",
                });

                gsap.to(dummy.scale, {
                    x: 0, y: 0, z: 0,
                    duration: 2, delay: 0.1, ease: "power4.in",
                    onUpdate: (indexOfInstance, dummy) => {
                        dummy.updateMatrix();
                        this._platformInstanceObject.setMatrixAt(indexOfInstance, dummy.matrix);
                        this._platformInstanceObject.instanceMatrix.needsUpdate = true;
                    },
                    onUpdateParams: [indexOfInstance, dummy],
                });

                // Return the piece to its original position under all the platforms
                gsap.delayedCall(3, () => {
                    // if (levelOfPlatform > GameConfig.levelGenerator[0].count) {
                    //console.clear();
                    // console.log(levelOfPlatform, ">", this.loopIndexLimit);
                    // console.log(GameConfig.gravitationalAcceleration, ",", GameConfig.movementCircleDuration);

                    if (GameConfig.movementCircleDuration - GameConfig.movementCircleDurationAccCoef >= GameConfig.movementCircleDurationLimit) {
                        GameConfig.movementCircleDuration -= GameConfig.movementCircleDurationAccCoef;
                    } else {
                        GameConfig.movementCircleDuration = GameConfig.movementCircleDurationLimit;
                    }


                    if (GameConfig.gravitationalAcceleration * GameConfig.gravitationalAccelerationAccCoef <= GameConfig.gravitationalAccelerationLimit) {
                        GameConfig.gravitationalAcceleration *= GameConfig.gravitationalAccelerationAccCoef;
                    } else {
                        GameConfig.gravitationalAcceleration = GameConfig.gravitationalAccelerationLimit;
                    }




                    if (levelOfPlatform > this.loopIndexLimit) {
                        //GameConfig.levelGenerator[0].count
                        const indexOfInstance = randChunkIndexRequestedPlatform[index];

                        this._platformPiecesData[indexOfInstance].layer += this._platformTotalLayerNum + 1 - this.loopIndexLimit - 1;
                        this._platformPiecesData[indexOfInstance].position.y = dummyOriginalPositionY - (this._platformTotalLayerNum + 1 - this.loopIndexLimit - 1) * GameConfig.platformOffset;
                        //console.log("this._platformPiecesData[indexOfInstance]", this._platformPiecesData[indexOfInstance]);

                        // Randomize the rotation
                        this._platformPiecesData[indexOfInstance].rotation.y += randomRotationAddon;

                        // Restore position rotation scale
                        dummy.position.set(this._platformPiecesData[indexOfInstance].position.x, this._platformPiecesData[indexOfInstance].position.y, this._platformPiecesData[indexOfInstance].position.z);
                        dummy.rotation.set(this._platformPiecesData[indexOfInstance].rotation.x, this._platformPiecesData[indexOfInstance].rotation.y, this._platformPiecesData[indexOfInstance].rotation.z);
                        dummy.scale.set(this._platformPiecesData[indexOfInstance].scale.x, this._platformPiecesData[indexOfInstance].scale.y, this._platformPiecesData[indexOfInstance].scale.z);

                        // Restore color
                        if (this._platformPiecesData[indexOfInstance].type === "normalPlatform") {
                            this._platformInstanceObject.setColorAt(indexOfInstance, new THREE.Color(GameManager.gameColors.normalPlatformColor));
                        }
                        else if (this._platformPiecesData[indexOfInstance].type === "losePlatform") {
                            this._platformInstanceObject.setColorAt(indexOfInstance, new THREE.Color(GameManager.gameColors.losePlatformColor));
                        }
                        else {
                            console.error("Invalid element type: " + indexOfInstance + " of this._platformPiecesData");
                        }

                        this._platformInstanceObject.instanceColor.needsUpdate = true;

                        dummy.updateMatrix();
                        this._platformInstanceObject.setMatrixAt(indexOfInstance, dummy.matrix);
                        this._platformInstanceObject.instanceMatrix.needsUpdate = true;
                    }
                });
            }
        }
    }

    pause() {
        this.pauseElapsedTime = this.clock.elapsedTime;
        this.clock.stop();
    }

    resume() {
        this.clock.start();
        this.clock.elapsedTime = this.pauseElapsedTime;
    }

    restart() {
        console.log("Platform restart");

        this._droppingDistance = 0;
        this._scoreBoostMultiplier = 0;
        this._scoreBoost = 0;
        this._platformLevelIndex = 0;
        this._lastBoostArrowLevel = 0;
        this._isBoostAnimationPlaying = false;
        this._platfromLevelDestroyedList = [];

        this.position.y = 0;
        this.rotation.y = 0;
        this._destroyAllPlatforms();
        this._setupRespawnPlatform();
        this._setupRandomPlatforms();
        this._setupBoostArrow();
        this._renderInstance();

        GameManager.SCORE = 0;
        GameConfig.happyTimeShowed = false;
        GameConfig.startedBestScore = GameManager.BEST_SCORE;
    }

    retry() {
        console.log("Platform retry");

        this._platfromLevelDestroyedList.splice(0, 1);

        this.rotation.y = 0;
        let rotationIndex = 1;
        this._platformLevelIndex -= 1;
        //console.log("this._platformLevelIndex", this._platformLevelIndex);
        this._isFirstGoingDownAfterRetry = true;

        // Place the platform on the right position
        const platformPositionY = this.position.y;
        //console.log(platformPositionY, Math.round(platformPositionY / GameConfig.platformOffset) * GameConfig.platformOffset);
        this.position.y = Math.round(platformPositionY / GameConfig.platformOffset) * GameConfig.platformOffset;

        // Move the instance of the respawn platform back to origin position
        for (let index = 0; index < 28; index++) {
            let dummy = new THREE.Object3D();
            rotationIndex -= 0.75;

            let positionWorld = new THREE.Vector3(0, -0.47223 + GameConfig.platformOffset, 0);
            let positionLocal = this.worldToLocal(positionWorld);
            let rotation = new THREE.Vector3(0, (rotationIndex / 4 + 2.5), 0);
            let scale = new THREE.Vector3(1, 1, 1);

            dummy.position.set(positionLocal.x, positionLocal.y, positionLocal.z);
            dummy.rotation.set(rotation.x, rotation.y, rotation.z);
            dummy.scale.copy(scale);

            dummy.updateMatrix();
            this._platformInstanceObject.setMatrixAt(index, dummy.matrix);
            this._platformInstanceObject.instanceMatrix.needsUpdate = true;

            this._platformPiecesData[0] = {
                position: positionLocal.clone(),
                rotation: rotation.clone(),
                scale: scale.clone(),
            };
        }

        this.translateY(-GameConfig.platformOffset);

        // Hide all the splashMesh
        for (let index = 0; index < this._currentSplashMeshed.length; index++) {
            this._currentSplashMeshed[index].visible = false;
        }

        config.losePlatformTouched = false;

    }






    touchBoostArrow() {
        console.log("touchBoostArrow");

        if (config.losePlatformTouched) {
            return;
        }

        GameManager.ball.isBooster = true;

        // Dispatch the event
        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "useBooster" });

        // Initialize some default variables
        const numberOfLayerDestroy = 4;
        const arrayLevelPlatformDestroy = [];

        // Show praises
        GameManager.uiManager.showPraises();

        // Set the delay of destroy according to the current velocity
        const acc = GameConfig.gravitationalAcceleration * 4;
        const destroyDelayArray = [];
        for (let index = 0; index < numberOfLayerDestroy; index++) {
            if (index === 0) {
                destroyDelayArray.push(0);
            }
            else {
                var totalDelay = (-this._ballVelocity + Math.sqrt((this._ballVelocity) ** 2 + 2 * acc * GameConfig.platformOffset * index)) / acc;
                destroyDelayArray.push(totalDelay);
            }
        }

        //console.log(destroyDelayArray[destroyDelayArray.length - 1]);

        // Change the ball state
        GameManager.EVENT_DISPATCHER.dispatchEvent({ type: "ballStatusChange", data: 'superFire' });

        // Hide all the splashMesh
        for (let index = 0; index < this._currentSplashMeshed.length; index++) {
            this._currentSplashMeshed[index].visible = false;
        }

        // Get the array of platforms to be destroyed
        var currentPlatformIndex = this._platformLevelIndex;
        for (let index = 0; index < numberOfLayerDestroy; index++) {
            arrayLevelPlatformDestroy.push(currentPlatformIndex);
            currentPlatformIndex += 1;
        }
        //console.log(arrayLevelPlatformDestroy);

        // Destroy platforms one by one
        for (let index = 0; index < arrayLevelPlatformDestroy.length; index++) {
            gsap.delayedCall(destroyDelayArray[index], () => {
                this.destroyPlatform(arrayLevelPlatformDestroy[index], "changeToRed");
            });
        }

        // Set the ball invincible
        this._isBallInvincible = true;
        this.invinsibleCheck();

        // Stop the ball bounce animation
        GameManager.ball.stopBounceAnimation();

        if (!this._isGoingDown) {
            this.goingDown(false, false);
        }
    }


    invinsibleCheck() {
        // disable invinsible bug !
        this.checkTimer && clearTimeout(this.checkTimer);
        this.checkTimer = setTimeout(() => {
            //pourquoi cette ligne ici ? car ça ne detruit pas la platform apres une longe chute
            // this._isBallInvincible = false;
            GameManager.ball.isBooster = false;
        }, 2000);

    }




    changeSkin(skinName) {
    }

    _detectAABBCollision() {
        // Setup boost arrow box
        const boundingBoxMin = new THREE.Vector3(-0.1, 0.4, -2.5);
        const boundingBoxMax = new THREE.Vector3(0.1, 0.5, -2);
        this._ballBox = new THREE.Box3(boundingBoxMin, boundingBoxMax);

        // Setup boost arrow box
        for (let index = 0; index < this._boostArrowsArray.length; index++) {
            const _boostArrow = this._boostArrowsArray[index];
            const boostArrowBox = new THREE.Box3().setFromObject(_boostArrow);

            if (this._ballBox.intersectsBox(boostArrowBox)) {
                this.remove(_boostArrow);
                this.touchBoostArrow();
            }
        }
    }

    _setupInvincibleCollisionEffect() {
        const geometry = new THREE.TorusGeometry(2.5, 1, 16, 30);
        const material = new THREE.MeshPhongMaterial({ color: 0xba0000, opacity: 0.5, transparent: true, depthWrite: false });
        this._invincibleCollisionEffect = new THREE.Mesh(geometry, material);

        this._invincibleCollisionEffect.rotation.x += Math.PI / 2;
        this._invincibleCollisionEffect.position.set(0, 0, 0);
        this._invincibleCollisionEffect.scale.set(0, 0, 0);
        this.add(this._invincibleCollisionEffect);
    }

    _setupSplashTextures(index) {
        const name = `splash_${index}`;

        var splashMaterial = new THREE.MeshPhongMaterial({ map: AssetsManager.texturesThree[name], transparent: true, depthWrite: false });
        var splashGeometry = new THREE.PlaneGeometry(1.3, 1.3);
        const splashMesh = new THREE.Mesh(splashGeometry, splashMaterial);
        splashMesh.rotation.x -= Math.PI / 2;

        this._splashMeshes.push(splashMesh);
    }

    _setupRespawnPlatform(type = "restart") {
        let rotationIndex = 1;
        this._colliderGroupRespawn = [];

        for (let i = 0; i < 28; i++) {
            rotationIndex -= 0.75;

            let position = new THREE.Vector3(0, -0.47223, 0);

            let rotation = new THREE.Vector3(0, (rotationIndex / 4 + 2.5), 0);
            let scale = new THREE.Vector3(1, 1, 1);
            let type = "normalPlatform";

            this._platformPiecesData.push({
                position: position.clone(),
                rotation: rotation.clone(),
                scale: scale.clone(),
                type: type,
                layer: 0,
                layerIndex: i,
            });
        }
    }

    _setupRandomPlatforms() {
        var platformIndex = 0;

        for (let index1 = 0; index1 < GameConfig.levelGenerator.length; index1++) {
            for (let index2 = 0; index2 < GameConfig.levelGenerator[index1].count; index2++) {
                platformIndex += 1;

                this._platGroupArr = [];
                const levelIndex = `level_0${GameConfig.levelGenerator[index1].level}`;
                //console.log("levelIndex", levelIndex);

                const randomPlatformStruct = PlatformsDesign[levelIndex][Math.floor(Math.random() * PlatformsDesign[levelIndex].length)];
                //console.log("randomPlatformStruct", randomPlatformStruct);

                let typePiece = randomPlatformStruct.type;

                let pieceData;
                for (let i = 0; i < randomPlatformStruct.count; i++) {
                    let positionY = - 0.47223 - (platformIndex * GameConfig.platformOffset);
                    let position = new THREE.Vector3(0, positionY, 0);
                    //console.log(randomPlatformStruct.rotation[i] / 4 * this._rotationValue + randomPlatformStruct.randomRotation);
                    //let rotation = new THREE.Vector3(0, - randomPlatformStruct.randomRotation ? randomPlatformStruct.rotation[i] / 4 * this._rotationValue + randomPlatformStruct.randomRotation : randomPlatformStruct.rotation[i] / 4 * this._rotationValue, 0);
                    let rotation = new THREE.Vector3(0, randomPlatformStruct.rotation[i] / 4 * this._rotationValue + randomPlatformStruct.randomRotation, 0);
                    let scale;
                    let type;
                    if (GameConfig.platformPieceType[typePiece[i]].type === GameConfig.losePiece) {
                        scale = new THREE.Vector3(1.02, 1.02, 1.02);
                        type = "losePlatform";
                    } else {
                        scale = new THREE.Vector3(1, 1, 1);
                        type = "normalPlatform";
                    }

                    pieceData = {
                        position: position.clone(),
                        rotation: rotation.clone(),
                        scale: scale.clone(),
                        type: type,
                        layer: platformIndex,
                        layerIndex: i,
                    };

                    this._platformPiecesData.push(pieceData);

                }
                this._platformArr[platformIndex] = pieceData;
            }
        }

        // Save the total number of layer of this platform
        this._platformTotalLayerNum = platformIndex;
        //console.log("this._platformTotalLayerNum", this._platformTotalLayerNum);
    }

    _setupBoostArrow() {
        //console.log("BoostArrow is already", this._platformLevelIndex, this._lastBoostArrowLevel);
        if (this._platformLevelIndex === this._lastBoostArrowLevel + 2) {

            let _arrowNbr = 3;
            let _arrowSteps = 8;

            if (GameManager.GAME.isDebug) {
                _arrowSteps = 1;
            }

            // Clean the boost arrows array
            for (let index = 0; index < this._boostArrowsArray.length; index++) {
                const boostArrow = this._boostArrowsArray[index];
                this.remove(boostArrow);
            }
            this._boostArrowsArray = [];

            // Generate the boost arrows
            for (let index = 0; index < _arrowNbr; index++) {
                let _boostArrow = AssetsManager.models.BoostArrow.scene.clone();

                const arrowPlatformLevel = this._platformLevelIndex + 3 + _arrowSteps * index;

                if (arrowPlatformLevel >= this._lastBoostArrowLevel) {
                    this._lastBoostArrowLevel = arrowPlatformLevel;
                }

                // let randomRotation = tools.angle2pos({ x: 0, y: 0 }, 1.95, tools.range(20, 180));
                let listNormalPiece = this._platformPiecesData.filter(element => element.layer === arrowPlatformLevel && element.type === "normalPlatform");
                if (listNormalPiece.length > 0) {
                    let rotationEuler = (listNormalPiece[Tools.randomNum(0, listNormalPiece.length - 1)].rotation.y - Math.PI / 2 + Math.PI / 36) * 180 / Math.PI;
                    let randomRotation = tools.angle2pos({ x: 0, y: 0 }, 1.95, rotationEuler);

                    _boostArrow.position.z = randomRotation.x;
                    _boostArrow.position.x = randomRotation.y;

                    //_boostArrow.position.y = this._platformArr[arrowPlatformLevel].position.y + 0.6;
                    _boostArrow.position.y = 0.47223 - (arrowPlatformLevel * GameConfig.platformOffset);
                    //console.log(_boostArrow.position.y);

                    gsap.to(_boostArrow.rotation, { y: Math.PI * 2, repeat: -1, ease: 'none', duration: 4 });
                    this.add(_boostArrow);
                    this._boostArrowsArray.push(_boostArrow);
                }
            }
        }
    }

    _renderInstance() {
        //console.log("renderInstance");

        let platformPieceGeometry = AssetsManager.models.PieMin.scene.children[0].geometry;
        let platformPieceMaterial = new THREE.MeshStandardMaterial({ side: THREE.DoubleSide, metalness: 0.05 });
        this._platformInstanceObject = new THREE.InstancedMesh(platformPieceGeometry, platformPieceMaterial, this._platformPiecesData.length);
        this._platformInstanceObject.receiveShadow = true;
        this._platformInstanceObject.castShadow = true;
        this._platformInstanceObject.name = "platformInstance";

        this.dummy = new THREE.Object3D();

        for (let index = 0; index < this._platformPiecesData.length; index++) {
            const element = this._platformPiecesData[index];

            this.dummy.position.copy(element.position);
            this.dummy.rotation.set(element.rotation.x, element.rotation.y, element.rotation.z);
            element.scale.y = GameConfig.platformYScale;
            this.dummy.scale.copy(element.scale);
            this.dummy.updateMatrix();
            this._platformInstanceObject.setMatrixAt(index, this.dummy.matrix);

            if (element.type === "normalPlatform") {
                this._platformInstanceObject.setColorAt(index, new THREE.Color(GameManager.gameColors.normalPlatformColor));
            }
            else if (element.type === "losePlatform") {
                this._platformInstanceObject.setColorAt(index, new THREE.Color(GameManager.gameColors.losePlatformColor));
            }
            else {
                console.error("Invalid element type: " + index + " of this._platformPiecesData");
            }
        }

        this.add(this._platformInstanceObject);
    }

    _destroyAllPlatforms() {
        // Clear all platforms
        this._platformPiecesData = [];
        this.remove(this._platformInstanceObject);

        // Clear the boost arrow
        for (let index = 0; index < this._boostArrowsArray.length; index++) {
            const boostArrow = this._boostArrowsArray[index];
            this.remove(boostArrow);
        }

        this._boostArrowsArray = [];
    }



    updateColor() {

        this._normalPlatformMaterial.color.set(GameManager.gameColors.normalPlatformColor);
        this._bonusPlatformMaterial.color.set(GameManager.gameColors.ballColorNormal);
        this._losePlatformMaterial.color.set(GameManager.gameColors.losePlatformColor);

    }





}